// extracted by mini-css-extract-plugin
export default {"Attendance":"Attendance_Attendance__wnUW+","TableDiv":"Attendance_TableDiv__ELTqN"};